import {FC} from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../modules/auth'
import {WithChildren} from '../../_metronic/helpers'

const ExternalUserGuard: FC<WithChildren> = ({children}) => {
  const {currentUser} = useAuth()

  if (currentUser?.external_user) {
    return <Navigate to='/error/403' replace />
  }

  return <>{children}</>
}

export {ExternalUserGuard}

